import React, { Component } from "react";
import axios from "axios";
//import PropTypes from "prop-types";
import settings from "client.settings.json";
import "./loginSms.css";
//import PhoneInput, { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input'
import { connect } from "react-redux";
import { translate } from "reducers/i18n";


class LoginSms extends Component {
  state = {
    loading: false,
    phonenumber: '',
    phones: [],
    smscode: '',
    messageIdIsValid: false,
    codeIsRequested: false,
    error: null,
    retry: null,
    isNotMyPhone: false,
  };

  componentDidMount() {
    this.validateMessageId();
  }

  render() {
    return (
      <div className="loginSmsForm panel">
        <div className="panelHeader header_fontFamily"><h1>{translate("_login")}</h1></div>

        {(() => {

          if (this.state.loading)
            return <div className="panelContent"><p>{translate("_isLoading")}...</p></div>

          else if (this.state.error)
            return <div>
              <div className="panelContent">
                <p>
                  {translate("_something_went_wrong")}: &nbsp;
                    { this.state.error.response?.data?.errorcode
                      ? translate(this.state.error.response?.data?.errorcode)
                      : this.state.error.message
                    }
                </p>
              </div>
              <div className="panelFooter buttons_fontFamily">
                {this.state.retry
                  ? <button title={translate("_tryAgain")} className="button  " onClick={() => { this.setState({ error: null }); this.state.retry(); }}>{translate("_tryAgain")}</button>
                  : <button title={translate("_tryAgainLater")} className=" button" disabled={true}>{translate("_tryAgainLater")}</button>
                }
              </div>
            </div>

          else if (this.state.codeIsRequested)
            return <div>
              <div className="panelContent">
                <p>{translate("smslogin_codeIsSend", this.state.phones.find(phone => phone._id === this.state.selectedPhone)?.numberMasked  || "")}</p>
                <input
                  className="code"
                  autoFocus={true}
                  type="text"
                  inputMode="numeric"
                  enterkeyhint={translate('_submit')}
                  key="code"
                  placeholder="Code"
                  onChange={event => { this.setState({ smscode: event.target.value }) }}
                  onKeyPress={e => { if (e.key === 'Enter') this.validateCode() }}
                />
              </div>
              <div className="panelFooter buttons_fontFamily">
                <button title={translate("_validateCode")} className="button primary " onClick={this.validateCode}>{translate("_validateCode")}</button>
              </div>
            </div>

          else if (this.state.isNotMyPhone === 'needConfirmation')
            return <div>
              <div className="panelContent">
                <p>{translate("smslogin_confirmNotMyPhone")}</p>
              </div>
              <div className="panelFooter buttons_fontFamily">
                <button className="button primary" title={translate("_confirm")} onClick={this.isnotmyphone}>{translate("_confirm")}</button>
                <button className="button" title={translate("_cancel")} onClick={() => { this.setState({ 'isNotMyPhone': false }) }}>{translate("_cancel")}</button>
              </div>
            </div>

          else if (this.state.isNotMyPhone === 'confirmed')
            return <div>
              <div className="panelContent">
                <p>We hebben de verzender op de hoogte gebracht...</p>
              </div>
              <div className="panelFooter buttons_fontFamily">
                <button className="button primary" title={translate("_confirm")} disabled={true}>{translate("_confirm")}</button>
                <button className="button" title={translate("_cancel")}  disabled={true}>{translate("_cancel")}</button>
              </div>
            </div>

          else
            return <div>
              <div className="panelContent">
                <p>{translate("smslogin_selectPhone")}:</p>
                <div  >
                  {this.state.phones.map(phone=>(
                    <div key ={`phone_${phone._id}`}>
                      <input onChange={this.onChangePhoneSelect} checked={this.state.selectedPhone === phone._id} type="radio" value={phone._id} id={`phone_${phone._id}`} name="phonenumber"  /> &nbsp;
                      <label htmlFor={`phone_${phone._id}`}>{phone.numberMasked}</label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="panelFooter buttons_fontFamily">
                <button title={translate("smslogin_sendCode")} className="button primary " onClick={this.requestCode}>{translate("smslogin_sendCode")}</button>
                <button title={translate("smslogin_isNotMyPhone")} className="button" onClick={() => { this.setState({ 'isNotMyPhone': 'needConfirmation' }) }}>{translate("smslogin_isNotMyPhone")}</button>
              </div>
            </div>

        })()}

      </div>
    );
  }


  onChangePhoneSelect = (e) => {
      this.setState({selectedPhone:e.target.value})
  }
  validateMessageId = () => {
    this.setState({ loading: true });
    axios({
      url: settings.api + "/api/login/smslogin/validatemessageid",
      method: "post",
      data: {
        messageId: this.props.match.params.messageId
      }
    }).then(
      response => {
        if ( response && response.data)
          this.setState({ loading: false, messageIdIsValid: true, phonenumber: response.data.phone || "", phones: response.data.phones, selectedPhone: response.data?.phones[0]?._id || "" });
        else
          this.setState({ loading: false, messageIdIsValid: false });
      },
      error => {  this.setState({ loading: false, error: error, retry: (() => { this.validateMessageId(); }) }) }
    );

  }

  requestCode = () => {
    this.setState({ loading: true });
    axios({
      url: settings.api + "/api/login/smslogin/requestcode",
      method: "post",
      data: {
        messageId: this.props.match.params.messageId,
        phoneId: this.state.selectedPhone,
      }
    }).then(
      response => this.setState({ loading: false, codeIsRequested: true }),
      error => this.setState({ loading: false, error: error, retry: (() => { this.requestCode(); }) })
    );
  };


  validateCode = () => {
    this.setState({ loading: true });
    axios({
      url: settings.api + "/api/login/smslogin/validatecode",
      method: "post",
      data: {
        messageId: this.props.match.params.messageId,
        smscode: this.state.smscode
      }
    }).then(
      response => {},
      error => this.setState({ loading: false, error: error, retry: (() => { }) })
    );
  }

  isnotmyphone = () => {
    this.setState({ loading: true });
    axios({
      url: settings.api + "/api/login/smslogin/isnotmyphone",
      method: "post",
      data: {
        messageId: this.props.match.params.messageId
      }
    }).then(
      response =>  this.setState({ loading: false, 'isNotMyPhone': 'confirmed' }),
      error => this.setState({ loading: false, error: error, retry: (() => { this.requestCode(); }) })
    );
  };


}

const mapStateToProps = (state) => state.i18n;
export default connect(mapStateToProps)(LoginSms);



//export default LoginSms


